// extracted by mini-css-extract-plugin
export default {"disabled":"eFYpqPGLc3ANREo1ooHU","territory":"e0vnSiqf2esnrogcMLHn"};